export default __webpack_public_path__ + "static/media/dettagli2.b12daa26.jpg";